import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Loading from '../../common/icons/Loading';
import Error from '../../common/icons/Error';
import TableComponent from './TableComponent';
import SimpleList from './SimpleList';
import PaginationBar from '../../common/PaginationBar';
import SelectPlacement, { usePlacement } from '../../common/SelectPlacement'


const CampaignsComponent = ({
  isLoading,
  data,
  onOrderByChange,
  setPage,
  openDeleteModal,
  limit,
  page,
  orderBy,
  ascending,
}) => {
  const {
    state,
    dispatch,
    render,
  } = usePlacement()
  const isMobile = useMediaQuery('(max-width:900px)');
  if (isLoading) {
    return <Loading />;
  }
  if (!data) {
    return <Error />;
  }

  const { data: campaignsAll, total } = data;

  const campaignsForPlacement = campaignsAll.filter(({ placement }) =>
    state.placementSelected === 'all' || placement._id === state.placementSelected);

  const pages = Math.ceil(total / limit);
  return render(() => (
    <>
      <SelectPlacement state={state} dispatch={dispatch} />
      {isMobile
        ? <SimpleList
          data={campaignsForPlacement}
          openDeleteModal={openDeleteModal}
        />
        : <TableComponent
          data={campaignsForPlacement}
          orderBy={orderBy}
          ascending={ascending}
          onOrderByChange={onOrderByChange}
          openDeleteModal={openDeleteModal}
        />
      }
      {pages > 1 && (
        <PaginationBar
          pages={pages}
          active={page}
          setPage={setPage}
        />
      )}
    </>
  ));
};


CampaignsComponent.defaultProps = {
  data: null,
};

CampaignsComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    data: PropTypes.array,
    total: PropTypes.number,
  }),
  onOrderByChange: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  openDeleteModal: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  orderBy: PropTypes.string.isRequired,
  ascending: PropTypes.oneOf([0, 1]).isRequired,
};

export default CampaignsComponent;
